import FooterComponent from "./footerComponent";
export default FooterComponent;